import { render, staticRenderFns } from "./group-detail-overview.vue?vue&type=template&id=419c944a&"
import script from "./group-detail-overview.ts?vue&type=script&lang=js&"
export * from "./group-detail-overview.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports